import type { CulturesNorce } from "~/types/components/header";
import type { Locale } from "~/types/locale";

export const CULTURE_LABELS: Record<string, string> = {
	se: "Svenska",
	us: "English (US)",
	ro: "Română",
	de: "Deutsch",
	fr: "Français",
	nl: "Nederlands",
	no: "Norsk",
	nb: "Norsk",
	dk: "Dansk",
	uk: "English (UK)",
	global: "International"
};

export function getCulturesFromLocales(locales: Locale[]): CulturesNorce[] {
	const list = locales ?? [];
	return list.map((locale) => {
		const value = locale.iso ?? locale.code;
		return {
			label: locale.name || CULTURE_LABELS[locale.code] || locale.code,
			value,
			code: locale.code
		};
	});
}
